import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { PVSystInfo } from "./PVSystInfo";
import { useContext } from "react";
import { UsinasContext } from "../context/UsinasContextProvider";
import { DialogHeader } from "../../../auth/components/PasswordRecoveryModal";
import BaseButton from "../../../main/components/BaseButton";

export function PVSystInfoModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const { pvSyst } = useContext(UsinasContext);
  const { open, setOpen } = props;
  const onClose = () => setOpen(false);

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        Dados do PVSyst
      </DialogHeader>
      <DialogContent
        sx={{
          minHeight: "400px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          overflowY: "auto",
        }}
        dividers
      >
        {pvSyst && <PVSystInfo pvSyst={pvSyst} />}
      </DialogContent>
      <DialogActions>
        <BaseButton
          sx={{ width: "fit-content" }}
          title="Fechar"
          onClick={onClose}
        />
      </DialogActions>
    </Dialog>
  );
}
